<template>
  <div class="divide-y divide-gray-400">
    <DeliveryScheduleDay
      v-for="(day, i) in form"
      :key="i"
      @update:day="dayChanged($event)"
      :day="day"
    />
  </div>
</template>

<script>
import DeliveryScheduleDay from '@/Partials/Regions/DeliveryScheduleDay'

export default {
  components: {
    DeliveryScheduleDay
  },

  props: {
    schedule: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: []
    }
  },

  created() {
    this.setSchedule(this.schedule)
  },

  watch: {
    schedule(newSchedule, oldSchedule) {
      this.setSchedule(newSchedule)
    }
  },

  computed: {},

  methods: {
    setSchedule(schedule) {
      this.form = schedule
    },
    scheduleChanged(event) {
      this.emitSchedule()
    },
    dayChanged(event) {
      const schedule = _.map(this.form, (day) => {
        if (event.day_of_week === day.day_of_week) {
          return Object.assign({}, event)
        }

        return day
      })

      this.setSchedule(schedule)
      this.emitSchedule()
    },
    emitSchedule() {
      this.$emit('update:schedule', this.form)
    }
  }
}
</script>
